/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "../AdminLogin/AdminLogin.css";
import PropTypes from "prop-types";
import errorMsg from "../../assets/json/errMsg.json";
import { DEFAULT_LANGUAGE } from "../../config";
import { Textbox } from "../../assets/component/Textbox";
import { validLogin } from "../../assets/validators/login.js";
import { checkEmail } from "../../assets/validators/common.js";
import { Link } from "react-router-dom";
import { renderLanguageSelector } from "../../assets/component/renderLanguageSelector.js";
import { LANGUAGE_LABELS } from "../AdminLogin/AdminLogin";

class AdminLoginPassword extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.state === undefined) {
      if (this.props.history.length <= 1) {
        this.props.history.push("/");
        return;
      } else {
        this.props.history.push("/LoginEmail");
        return;
      }
    }
    this.state = {
      username: this.props.location.state.username,
      password: "",
      checkData: false,
      errMsg: {
        username: "",
        password: "",
      },
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  handleEmailChange(e) {
    let errMsg = this.state.errMsg;
    errMsg.username = "";
    this.setState({
      errMsg: errMsg,
      username: e,
    });
  }

  handleChange(e) {
    let errMsg = this.state.errMsg;
    errMsg.password = "";
    this.setState({
      password: e,
      errMsg: errMsg,
    });
  }

  reroute() {
    // Validate here rather than trusting the last blur, so Enter works
    // straight after typing. Mirrors validLogin (email, 8+ char password).
    if (!checkEmail(this.state.username) || this.state.password.length < 8) {
      this.setState({ checkData: true });
      return false;
    }

    let errMsg = { username: "", password: "" };
    const errMsgData = errorMsg[this.props.language] || errorMsg[DEFAULT_LANGUAGE];

    this.props
      .adminLogin({
        username: this.state.username,
        password: this.state.password,
      })
      .then((res) => {
        if (res.status === 204) {
          this.props.history.push({
            pathname: "/Admin",
          });
          return;
        }
        if (res.body && res.body.message === "Incorrect password") {
          errMsg.password = errMsgData.pwErr.passwdErr;
        } else if (res.body && res.body.errors && res.body.errors.username) {
          errMsg.username = errMsgData.loginErr.loginEmailErr;
        }
        this.setState({
          errMsg: errMsg,
          checkData: true,
        });
      });
  }

  render() {
    const languageObj = this.props.languageObj;
    const errMsgData =
      errorMsg[this.props.language] || errorMsg[DEFAULT_LANGUAGE];

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };
    return (
      <div className="AdminLogin-view">
        <div className="AdminLogin-topBar">
          <div className="AdminLogin-language">
            <svg
              className="AdminLogin-icon AdminLogin-iconSm"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            <span>{LANGUAGE_LABELS[this.props.language]}</span>
            <svg
              className="AdminLogin-icon AdminLogin-iconSm AdminLogin-chevron"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
            {renderLanguageSelector()}
          </div>
        </div>
        <div className="AdminLogin-card AdminLogin-card--withBack">
          <Link to={"/AdminLogin"} className="AdminLogin-back">
            <svg
              className="AdminLogin-icon AdminLogin-iconSm"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M15 6l-6 6 6 6" />
            </svg>
            {languageObj.back}
          </Link>

          <div className="AdminLogin-mark">
            <svg className="AdminLogin-icon" viewBox="0 0 24 24" aria-hidden="true">
              <rect x="5" y="11" width="14" height="10" rx="2" />
              <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
          </div>

          <h1 className="AdminLogin-title">{languageObj.title}</h1>

          <p className="AdminLogin-subtitle">{languageObj.text}</p>

          <div className="AdminLogin-field" onKeyDown={handleKeyDown}>
            <label className="AdminLogin-label" htmlFor="email">
              {languageObj.emailLabel}
            </label>
            <Textbox
              id={"email"}
              name="email"
              type="email"
              placeholder={languageObj.inputFieldContainer[0]}
              onChange={this.handleEmailChange}
              value={this.state.username}
              classNameInput="AdminLogin-inputField"
              classNameContainer="AdminLogin-Container"
              validate={this.state.checkData}
              validationCallback={() => {
                this.setState({ checkData: false });
              }}
              onBlur={(e) => {}}
              validationOption={{
                ...validLogin.username(this.state.errMsg.username || ""),
                msgOnError:
                  this.state.errMsg.username ||
                  errMsgData.loginErr.loginEmailErr,
              }}
            />
          </div>

          <div className="AdminLogin-field" onKeyDown={handleKeyDown}>
            <label className="AdminLogin-label" htmlFor="password">
              {languageObj.passwordLabel}
            </label>
            <Textbox
              id={"password"}
              name="password"
              type="password"
              placeholder={languageObj.inputFieldContainer[1]}
              onChange={this.handleChange}
              value={this.state.password}
              classNameInput="AdminLogin-inputField"
              classNameContainer="AdminLogin-Container"
              validate={this.state.checkData}
              validationCallback={() => {
                this.setState({ checkData: false });
              }}
              onBlur={(e) => {}}
              validationOption={{
                ...validLogin.password(this.state.errMsg.password || ""),
                msgOnError:
                  this.state.errMsg.password || errMsgData.pwErr.passwdErr,
              }}
            />
          </div>

          <button
            type="button"
            onClick={this.reroute}
            className="AdminLogin-submit"
          >
            {languageObj.submit}
          </button>
        </div>
      </div>
    );
  }
}
AdminLoginPassword.propTypes = {
  adminLogin: PropTypes.func,
  languageObj: PropTypes.object,
  language: PropTypes.string,
};

export default AdminLoginPassword;
